import type { ReactNode } from 'react'

import { Container } from '@twistopayments/design-system/components/atoms/container'
import { useRouter } from 'next/router'
import { isNil } from 'ramda'

import { useGetFlowData } from '@twisto/flow-views'

import { DebugInfo } from 'flow/components/debug-info'
import { FlowAppBar } from 'flow/components/flow-app-bar'

import { BaseLayout } from './base-layout'
import * as styles from './flow-layout.styles'
import { PayInNLayout } from './pay-in-n-layout'

type Props = {
  children: ReactNode
  withoutDebugInfo?: boolean
}

export const FlowLayout = ({ children, withoutDebugInfo = false }: Props) => {
  const { query } = useRouter()
  const sessionId = query.sessionId as string

  const { flow } = useGetFlowData(sessionId)
  const hasPurchaseContext =
    !isNil(flow?.context) || 'purchaseContext' in (flow?.currentStep || {})

  if (hasPurchaseContext) {
    return (
      <PayInNLayout withoutDebugInfo={withoutDebugInfo}>
        <Container noPadding css={styles.payInNContainer} size="small">
          <div css={styles.content}>{children}</div>
        </Container>
      </PayInNLayout>
    )
  }

  return (
    <>
      <FlowAppBar />
      <BaseLayout>
        <Container noPadding css={styles.container} size="small">
          {children}
        </Container>
        {withoutDebugInfo ? null : <DebugInfo />}
      </BaseLayout>
    </>
  )
}
